import { render, staticRenderFns } from "./ServicePackageAdd.vue?vue&type=template&id=32d49eb8&"
import script from "./ServicePackageAdd.vue?vue&type=script&lang=js&"
export * from "./ServicePackageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports